import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, managerOnly = false, superAdminOnly = false, adminOrLeadOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-neutral-500 font-mono-tight text-sm">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (superAdminOnly && user.role !== "SuperAdmin") return <Navigate to="/" replace />;
  if (adminOrLeadOnly && !["SuperAdmin", "TeamLeader"].includes(user.role)) return <Navigate to="/" replace />;
  if (managerOnly && !["Manager", "SuperAdmin", "TeamLeader"].includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
